import * as types from '../constants/ActionTypes';

const initialState = {
  timestamp: new Date().getTime(),
  cliensideLinks: {
    pep: {
      product_pod: '_blank',
      see_full_details: '_blank'
    },
    pip: {
      product_pod: '_spa'
    },
    b: {
      product_pod: '_blank'
    },
    s: {
      product_pod: '_blank'
    }
  },
  rules: {
    pep: {},
    pip: {
      main: null,
      zone_a: null
    }
  }
};
/*

 { type: FEATURE_STATE_LINKS, page: 'b', tag: 'product_pod', value: true}
*/
function setFeatureStateLinks(cliensideLinks, action) {
  if (action.page === '*') {
    return Object.keys(cliensideLinks).reduce((acc, page) => {
      return {
        ...acc,
        [page]: {
          ...cliensideLinks[page],
          [action.tag]: action.value
        }
      };
    }, {});
  }
  return {
    ...cliensideLinks,
    [action.page]: {
      ...cliensideLinks[action.page],
      [action.tag]: action.value
    }
  };
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.UPDATE_SESSION_TIMESTAMP:
      return {
        ...state,
        timestamp: new Date().getTime()
      };
    case types.SESSION_FLUSH:
      return {
        timestamp: new Date().getTime(),
        ...initialState
      };
    case types.FEATURE_STATE_LINKS:
      return {
        ...state,
        cliensideLinks: { ...action.cliensideLinks }
      };
    case types.FEATURE_STATE_LINK:
      return {
        ...state,
        cliensideLinks: setFeatureStateLinks(state.cliensideLinks, action)
      };
    case types.FEATURE_STATE_RULES_RESET:
      return {
        ...state,
        rules: initialState.rules
      };
    case types.FEATURE_STATE_RULE:
      return {
        ...state,
        rules: {
          ...(state.rules || {}),
          [action.page]: {
            ...(state.rules || {})[action.page],
            [action.tag]: action.rule
          }
        }
      };
    default:
      return state;
  }
}

export function getLinkType({ state, page, tag }) {
  try {
    return state.cliensideLinks[page][tag];
  } catch (e) {
    return '_self';
  }
}

export function getRules({ state, page, defaultRules = {} }) {
  const rules = {
    [page]: { ...defaultRules }
  };
  Object.keys((state.rules[page] || {})).forEach((key) => {
    if (state.rules[page][key]) {
      rules[page][key] = state.rules[page][key];
    }
  });

  return rules[page];
}
